import { React, useState, useEffect } from "react";
import store from "../../../store";
import classes from './Screening.module.scss';
import { Link } from "react-router-dom";

//MUI Imports
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import Button from '@mui/material/Button';


function Screening({ schema, onUpdate, project }) {

  const [screenContent, setScreenContent] = useState(null);
  const [screeningLayerOptions, setScreeningLayerOptions] = useState(null)

  function onLayerChange(key, value){

    let layerListChange = JSON.parse(JSON.stringify(screeningLayerOptions))
    layerListChange[key] = value

    setScreeningLayerOptions({
      ...layerListChange,

    })

    onUpdate("screeningLayerOptions", layerListChange);

  }

  useEffect(() => {
    if(project){

      if(project.entries.screeningLayerOptions === undefined){

        setScreeningLayerOptions({})
      }else{

        setScreeningLayerOptions(project.entries.screeningLayerOptions)
      }

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[project])

  function getLayerChoices(forKey){
    return (
        <Switch 
            value={screeningLayerOptions[forKey]}
            checked={screeningLayerOptions[forKey]}
            name={forKey}
            onChange={(e) => {onLayerChange([forKey], e.target.checked)}}
            
        />
    )
}
  
  useEffect(() => {
    if(schema)
      setScreenContent(schema.screenContent.screening.descriptions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schema])

  return (
    <>
        {
          (
            screenContent ? 
            <Box className={`content_wrapper__inner`}>
            <Box className={`gain_content_container`}>
            
              {(screeningLayerOptions
                  ?
                  <section className={`${classes.Screening__form_container} gain_content_container__form_container`}>
                    <FormGroup className={`${classes.Screening__form_group}`}>
                      {
                        schema.entryOptions.screen.screening.fields.map((element, index) => {
                          return(
                            <div className={`${classes.Screening__form_group__switch}`} key={index}>
                              {getLayerChoices(element.key)}
                              <label className={`small_copy`} dangerouslySetInnerHTML={{__html:`${index+1}) ${element.label}`}}></label>
                            </div>
                          )
                        })
                      }
                    </FormGroup>
                    <Link className={"inline_button inline_button__large"} to={`${process.env.PUBLIC_URL}/project/${project.projectId}/${store.getState().pages.assessment.slug}`}>
                      <Button variant="contained">Get started</Button>
                    </Link>

                  </section>
                  :
                  ""
              )}
              <section className={`gain_content_container__guidance`}>
                {
                  screenContent.map((element, index) => {
                    return(
                      <div key={index} className={`${classes.Screening__guidance}`}>
                        <p className={`subtitle_copy`} dangerouslySetInnerHTML={{__html:element.heading}}></p>
                        <p className={`small_copy`} dangerouslySetInnerHTML={{__html:element.body}}></p>
                      </div>
                    )
                  })
                }
              </section>
            </Box>
          </Box>
            :
            ""
         )
        }
    </>
  );
}
export default Screening